import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import avatar from '../../../assets/img/cd-avatar.png';

export default function Header() {
  const navigate = useNavigate();
  const hasCheckedAuth = useRef(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    if (hasCheckedAuth.current) return;

    const isLoggedIn = sessionStorage.getItem('isLoggedIn');

    if (!isLoggedIn || isLoggedIn !== 'true') {
      alert('로그인이 필요합니다. 다시 로그인해주세요.');
      navigate('/admin', { replace: true });
    }

    hasCheckedAuth.current = true;
  }, [navigate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.has-children.account')) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = () => {
    // 로그아웃 확인 후 처리
    if (window.confirm('로그아웃 하시겠습니까?')) {
      sessionStorage.removeItem('isLoggedIn');
      alert('로그아웃되었습니다.');
      navigate('/admin', { replace: true });
    }
  };

  return (
    <>
    
      <header className="cd-main-header">
        <a href="/admin/event" className="cd-logo">
          크림봇 관리자
        </a>
        <a href="#0" className="cd-nav-trigger">
          Menu<span></span>
        </a>
        <nav className="cd-nav">
          <ul className="cd-top-nav">
            <li className="has-children account">
              <a href="#0" onClick={toggleDropdown}>
                <img src={avatar} alt="avatar" />
              </a>
              <ul className={isDropdownOpen ? 'show debug-visible' : ''}>
                <li>
                  <a href="/admin/updatePassword">회원정보 수정</a>
                </li>
                <li>
                  <button onClick={handleLogout}>Logout</button>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </header>
      <nav className="cd-side-nav">
        <ul>
          <li className="cd-label">Main</li>

          <li className="has-children overview">
            <a href="/admin/event">이벤트/소식</a>
          </li>

          <li className="has-children overview">
            <a href="/admin/review">설치사례</a>
          </li>

          <li className="has-children overview">
            <a href="/admin/contact">제휴문의</a>
          </li>

          <li className="has-children overview">
            <a href="/admin/service">고객센터(문의)</a>
          </li>
           <li className="has-children overview">
            <a href="/admin/faq">고객센터(FAQ)</a>
          </li>
           <li className="has-children overview">
            <a href="/admin/popup">팝업</a>
          </li>
        </ul>
      </nav>
    </>
  );
}
